/* ══════════════════════════════════════════════════════════
   YOURAYOU — Product Shared JS
   Image carousel, accordion, FAQ, discover slider,
   scroll reveal, sticky CTA
   Load with <script src="..." defer></script>
   ══════════════════════════════════════════════════════════ */
(function() {
  'use strict';

  function init() {

    /* ── Image carousel ── */
    var currentSlide = 0;
    var thumbs = document.querySelectorAll('.ya-gallery__thumb[data-index]');
    var totalSlides = thumbs.length;
    var mainImg = document.querySelector('.ya-gallery__main img');

    function goTo(idx) {
      if (!totalSlides || !mainImg) return;
      currentSlide = ((idx % totalSlides) + totalSlides) % totalSlides;
      thumbs.forEach(function(t, i) { t.classList.toggle('active', i === currentSlide); });
      mainImg.removeAttribute('srcset'); mainImg.src = thumbs[currentSlide].dataset.src || '';
    }

    /* Expose goTo for lightbox integration */
    window._yaGalleryGoTo = goTo;
    window._yaGalleryState = function() { return { currentSlide: currentSlide, totalSlides: totalSlides, mainImg: mainImg, thumbs: thumbs }; };

    var prevBtn = document.querySelector('.ya-gallery__nav--prev');
    var nextBtn = document.querySelector('.ya-gallery__nav--next');
    if (prevBtn) prevBtn.addEventListener('click', function(e) { e.stopPropagation(); goTo(currentSlide - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { e.stopPropagation(); goTo(currentSlide + 1); });
    thumbs.forEach(function(t, i) { t.addEventListener('click', function() { goTo(i); }); });

    /* Mobile swipe on main image */
    (function() {
      var mainImgWrap = document.querySelector('.ya-gallery__main');
      if (!mainImgWrap) return;
      var startX = 0, startY = 0, moving = false;
      mainImgWrap.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; startY = e.touches[0].clientY; moving = true; }, {passive:true});
      mainImgWrap.addEventListener('touchmove', function(e) { if (!moving) return; }, {passive:true});
      mainImgWrap.addEventListener('touchend', function(e) {
        if (!moving) return;
        moving = false;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) goTo(currentSlide + 1); else goTo(currentSlide - 1);
        }
      }, {passive:true});
    })();

    /* ── Accordion toggle ── */
    document.querySelectorAll('.ya-acc-trigger').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.ya-acc-item');
        var wrap = btn.closest('.ya-acc-wrap');
        var open = item.classList.contains('open');
        var siblings = wrap ? wrap.querySelectorAll('.ya-acc-item') : document.querySelectorAll('.ya-acc-item');
        siblings.forEach(function(i) { i.classList.remove('open'); });
        if (!open) item.classList.add('open');
      });
    });

    /* ── FAQ toggle ── */
    document.querySelectorAll('.ya-faq-q').forEach(function(btn) {
      btn.addEventListener('click', function() { btn.closest('.ya-faq-item').classList.toggle('open'); });
    });

    /* ── Discover slider (desktop 5/vue · mobile 2/vue) ── */
    (function() {
      var grid = document.querySelector('.ya-disc-grid');
      var nextBtn = document.querySelector('.ya-disc-next');
      if (!grid || !nextBtn) return;
      var pos = 0;
      function perView() { return window.innerWidth > 768 ? 5 : 2; }
      function pageWidth() {
        var wrap = grid.parentElement;
        return wrap ? wrap.clientWidth : grid.clientWidth;
      }
      function maxPos() { return Math.max(0, Math.ceil(grid.children.length / perView()) - 1); }
      function update() {
        grid.style.transform = 'translateX(-' + (pos * pageWidth()) + 'px)';
        nextBtn.style.opacity = pos >= maxPos() ? '0.3' : '1';
        nextBtn.style.display = maxPos() > 0 ? 'flex' : 'none';
      }
      nextBtn.addEventListener('click', function() {
        if (pos < maxPos()) pos++; else pos = 0;
        update();
      });
      window.addEventListener('resize', function() { pos = 0; update(); });
      update();
    })();

    /* ── Scroll reveal ── */
    var revObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('on'); revObs.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.ya-reveal').forEach(function(el) { revObs.observe(el); });

    /* ── Sticky CTA ── */
    function checkStickyVisibility() {
      var wrap = document.querySelector('.ya-sticky-cta');
      if (!wrap) return;
      if (window.innerWidth > 768) { wrap.classList.remove('show'); return; }
      var discover = document.querySelector('.ya-disc-section');
      var footer = document.querySelector('footer');
      var hideTarget = discover || footer;
      if (hideTarget) {
        var rect = hideTarget.getBoundingClientRect();
        if (rect.top < window.innerHeight) { wrap.classList.remove('show'); return; }
      }
      wrap.classList.add('show');
    }
    window.addEventListener('scroll', checkStickyVisibility, { passive: true });
    window.addEventListener('resize', checkStickyVisibility);
    checkStickyVisibility();

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── Panneau "VOTRE PACK" — rendu des emplacements ───────────────────────── */
(function() {
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Cache des données teintes (#shades-data, page starter). Vide si absent.
  var shadeMap = null;
  function buildShadeMap() {
    if (shadeMap) return shadeMap;
    shadeMap = {};
    var el = document.getElementById('shades-data');
    if (el) {
      try {
        JSON.parse(el.textContent).forEach(function(s) {
          shadeMap[s.name] = { img: s.preview || s.swatch || '', url: s.url || '#' };
        });
      } catch (e) {}
    }
    return shadeMap;
  }
  // Source d'image/url pour une teinte : #shades-data d'abord, sinon .c-dot (refill).
  function lookup(name) {
    var map = buildShadeMap();
    if (map[name]) return map[name];
    var dots = document.querySelectorAll('.c-dot');
    for (var i = 0; i < dots.length; i++) {
      if (dots[i].dataset.name === name) {
        return { img: dots[i].dataset.img || '', url: dots[i].dataset.url || '#' };
      }
    }
    return { img: '', url: '#' };
  }
  function render(maxD, selectedNames) {
    var box = document.getElementById('ya-pack-slots');
    if (!box) return;
    var html = '';
    for (var i = 0; i < maxD; i++) {
      var name = selectedNames[i];
      if (name) {
        var info = lookup(name);
        html += '<div class="ya-pack__slot ya-pack__slot--filled" data-zone="' + i + '">'
          + (info.img
              ? '<img class="ya-pack__thumb" src="' + esc(info.img) + '" alt="' + esc(name) + '" loading="lazy">'
              : '<span class="ya-pack__thumb ya-pack__thumb--ph"></span>')
          + '<span class="ya-pack__name">' + esc(name) + '</span>'
          + '<a class="ya-pack__view" href="' + esc(info.url) + '" target="_blank" rel="noopener">voir la fiche</a>'
          + '<button type="button" class="ya-pack__remove" data-remove="' + esc(name) + '" data-zone="' + i + '" aria-label="Retirer ' + esc(name) + '">&times;</button>'
          + '</div>';
      } else {
        html += '<div class="ya-pack__slot ya-pack__slot--empty" data-zone="' + i + '"><span class="ya-pack__plus">+</span></div>';
      }
    }
    box.innerHTML = html;
  }
  window.YAPack = { render: render };
})();
